import { db, storage } from './../config/Fire';
import * as Constants from './../constants/nodes_database';
import { setPlaces } from './dataForState/dataForProfile/setPlacesToState';

export const SAVING_CONFIG = 'SAVING_CONFIG';
export const SAVED_CONFIG = 'SAVED_CONFIG';

export const setSavingConfig = payload => ({ type: SAVING_CONFIG, payload });
export const setSavedConfig = payload => ({ type: SAVED_CONFIG, payload });

export const setImagesToMainSliderByCityAdmin = payload => {
    return dispatch => {
        var isSavingConfig = true;
        dispatch(setSavingConfig(isSavingConfig));
        const { imagesSlider, country, province, city } = payload;
        const imageNameSlider = `mainSlider/images/${country}/${province}/${city}`;
        const media = [];
        var promisesSaveImagesStorage = [];
        if(imagesSlider) {
            imagesSlider.forEach((image, index) => {
                if(image.originFileObj) {
                    var storageSlider = storage.ref().child(`${imageNameSlider}0${index + 1}`).put(image.originFileObj);
                    promisesSaveImagesStorage.push(storageSlider);
                }
                media.push(`${imageNameSlider}0${index + 1}`);
                return Promise.all(promisesSaveImagesStorage)
                .then(() => {
                    return db.ref(`${Constants.PLACES}`).once("value")
                    .then((placesSnap) => {
                        if(placesSnap.exists()) {
                            var places = placesSnap.val()
                            if(places[country] && places[country].provinces) {
                                places[country].provinces.forEach(provinceObject => {
                                    if(provinceObject.name === province) {
                                        provinceObject.cities.forEach(cityObject => {
                                            if(cityObject.name === city) {
                                                cityObject["mainSlider"] = media
                                            }
                                        });
                                    }
                                });
                            }
                            return db.ref(`${Constants.PLACES}`).set(places)
                            .then(() => {
                                dispatch(setPlaces(places));
                                dispatch(setSavingConfig(isSavingConfig = false));
                                var isSavedConfig = true;
                                dispatch(setSavedConfig(isSavedConfig));
                            })
                            .catch(err => {
                                console.log("not found save data");
                                dispatch(setSavingConfig(isSavingConfig = false));
                            });
                        } else {
                            console.log("not found save data");
                            dispatch(setSavingConfig(isSavingConfig = false));
                        }
                    })
                    .catch(err => {
                        console.log("not found save data");
                        dispatch(setSavingConfig(isSavingConfig = false));
                    });
                })
                .catch(err => {
                    console.log("not found save data");
                    dispatch(setSavingConfig(isSavingConfig = false));
                });
            });
        } else {
            return db.ref(`${Constants.PLACES}`).once("value")
            .then((placesSnap) => {
                if(placesSnap.exists()) {
                    var places = placesSnap.val()
                    if(places[country] && places[country].provinces) {
                        places[country].provinces.forEach(provinceObject => {
                            if(provinceObject.name === province) {
                                provinceObject.cities.forEach(cityObject => {
                                    if(cityObject.name === city) {
                                        cityObject["mainSlider"] = null
                                    }
                                });
                            }
                        });
                    }
                    return db.ref(`${Constants.PLACES}`).set(places)
                    .then(() => {
                        dispatch(setPlaces(places));
                        dispatch(setSavingConfig(isSavingConfig = false));
                        var isSavedConfig = true;
                        dispatch(setSavedConfig(isSavedConfig));
                    })
                    .catch(err => {
                        console.log("not found save data");
                        dispatch(setSavingConfig(isSavingConfig = false));
                    });
                } else {
                    console.log("not found save data");
                    dispatch(setSavingConfig(isSavingConfig = false));
                }
            })
            .catch(err => {
                console.log("not found save data");
                dispatch(setSavingConfig(isSavingConfig = false));
            });
        }
    };
};